import Page from "webPage/Page";
import Track from "util/Track";
import $ from "jquery";

Page.register('page-template-initiatives', () => {
    new Track($('.js-testimonials-track-wrap'), {
        classes: {
            block: "testimonials-track",
        },
    });
});